export const formatRedirectUrl = (url: string) => {
  const redirectTo = url.replace("@@base_domain@@", "");

  return redirectTo;
};
